import React from 'react'
import { Container, Row, Col } from "react-bootstrap";
import gradient from "../../Assets/gradient-hero-light.png";
import { Link } from "react-router";
import ContactBlock from "../ContactBlock";
import ServicesCard from "../../components/ServicesCard"
import Image from 'react-bootstrap/Image';
import { FaCheckCircle } from "react-icons/fa";
import cs1 from "../../Assets/case_study/1.png";
import cs2 from "../../Assets/case_study/2.png";
import cs3 from "../../Assets/case_study/3.png";

export default function WebApplication() {
    return (
        <div>
            <section className='bg-theme section-hero'>
                <Container fluid className="header-section">
                    <Row>
                        <Col md={12} >
                            <div className="padding-section-large text-center d-flex flex-column">
                                <div className="max-width-large mx-auto">
                                    <h1 className="heading-style-h1 text-white">Web Application Development</h1>
                                </div>
                                <div className='pt-2 max-width-large mx-auto'>
                                    <p className="text-size-medium">At Parabola IT Development, we bring deep technical expertise in building scalable, secure, and high-performing e-commerce platforms tailored for both B2B and B2C models. From custom storefronts to backend integrations, we help businesses launch, grow, and optimize their online presence with modern, conversion-focused solutions.</p>
                                </div>
                                <div className="pt-3 d-flex justify-content-center">
                                    <Link to="/contact" className="btn btn-dark rounded-pill px-5 py-3">Get In Touch</Link>
                                </div>
                            </div>
                        </Col>
                        <div className="pills-wrap">
                            <div className="hero-pill-left-wrap animation_slide-up-delay-2">
                                <Image src={gradient} />
                            </div>
                            <div className="hero-pill-right-wrap animation_slide-up-delay-2">
                                <Image src={gradient} />
                            </div>
                        </div>
                    </Row>
                </Container >
            </section >
            <section className='bg-white px-5 padding-section-large'>
                <h4 className='display-6 pb-3'>Some of the Projects that we worked on:</h4>
                <div className='d-flex mobile-wrap projects gap-3 col-lg-12'>
                    <div className='col-lg-6 col-12'>
                        <div className='d-flex align-items-center border-bottom border-top py-2'>
                            <div className='iconBlock me-3'>
                                <i class="fi fi-ts-check-circle main-name fs-1"></i>
                            </div>
                            <p>Largescale payment gateway migrations</p>
                        </div>
                        <div className='d-flex align-items-center border-bottom py-2'>
                            <div className='iconBlock me-3'>
                                <i class="fi fi-ts-check-circle main-name fs-1"></i>
                            </div>
                            <p>Building a streaming pipeline to replace batch ETL system</p>
                        </div>
                        <div className='d-flex align-items-center border-bottom py-2'>
                            <div className='iconBlock me-3'>
                                <i class="fi fi-ts-check-circle main-name fs-1"></i>
                            </div>
                            <p>Migration of mobile app from Ionic to Flutter</p>
                        </div>
                        <div className='d-flex align-items-center border-bottom py-2'>
                            <div className='iconBlock me-3'>
                                <i class="ffi fi-ts-check-circle main-name fs-1"></i>
                            </div>
                            <p>Marketing Libraries & Personal Webpages</p>
                        </div>
                        <div className='d-flex align-items-center border-bottom py-2'>
                            <div className='iconBlock me-3'>
                                <i class="fi fi-ts-check-circle main-name fs-1"></i>
                            </div>
                            <p>Migration of enterprise system from Magento to Ruby on Rails</p>
                        </div>
                        <div className='d-flex align-items-center border-bottom py-2'>
                            <div className='iconBlock me-3'>
                                <i class="fi fi-ts-check-circle main-name fs-1"></i>
                            </div>
                            <p>Building Customizable auto-responders</p>
                        </div>
                    </div>
                    <div className='col-lg-6 col-12'>
                        <div className='d-flex align-items-center border-bottom border-top py-2'>
                            <div className='iconBlock me-3'>
                                <i class="fi fi-ts-check-circle main-name fs-1"></i>
                            </div>
                            <p>Integration with local payments, payment wallets, various 3PLs</p>
                        </div>
                        <div className='d-flex align-items-center border-bottom py-2'>
                            <div className='iconBlock me-3'>
                                <i class="fi fi-ts-check-circle main-name fs-1"></i>
                            </div>
                            <p>Upgrading from Rails 3 to Rails 7</p>
                        </div>
                        <div className='d-flex align-items-center border-bottom py-2'>
                            <div className='iconBlock me-3'>
                                <i class="fi fi-ts-check-circle main-name fs-1"></i>
                            </div>
                            <p>Building Promotion Engine for Ecommerce</p>
                        </div>
                        <div className='d-flex align-items-center border-bottom py-2'>
                            <div className='iconBlock me-3'>
                                <i class="fi fi-ts-check-circle main-name fs-1"></i>
                            </div>
                            <p>Building Rep Journeys</p>
                        </div>
                        <div className='d-flex align-items-center border-bottom py-2'>
                            <div className='iconBlock me-3'>
                                <i class="fi fi-ts-check-circle main-name fs-1"></i>
                            </div>
                            <p>Building Fully localized content management systems</p>
                        </div>
                        <div className='d-flex align-items-center border-bottom py-2'>
                            <div className='iconBlock me-3'>
                                <i class="fi fi-ts-check-circle main-name fs-1"></i>
                            </div>
                            <p>Building Customizable report engine</p>
                        </div>
                    </div>
                </div>
            </section>
            <section className='bg-white px-0 px-md-5 pb-0 padding-section-large'>

                <div className='p-5 rounded-24 bg-grey'>


                    <h4 className='display-6 pb-3'>Our E-commerce Capabilities include:</h4>
                    <div className='d-flex flex-row gap-2'>
                        <div><FaCheckCircle size={20} style={{ "color": "#1D69BC" }} /></div>
                        <p>Experience with major platforms: Shopify, Magento, WooCommerce, and Spree Headless Commerce Architecture for speed, flexibility, and omnichannel experiences</p>
                    </div>
                    <div className='d-flex flex-row gap-2'>
                        <div><FaCheckCircle size={20} style={{ "color": "#1D69BC" }} /></div>
                        <p>Seamless Payment Gateway Integrations (Stripe, Authorize.Net, Braintree, Worldpay, etc.) Multi-vendor & Subscription Models, Autoship, and Dynamic Pricing Integration with ERP's like Bluelink, Exigo, Infotrax, ByDesign</p>
                    </div>
                    <div className='d-flex flex-row gap-2'>
                        <div><FaCheckCircle size={20} style={{ "color": "#1D69BC" }} /></div>
                        <p>Integration with CRM, Tax (Avalara), and Fraud Detection Systems (Kount, Sift)</p>
                    </div>
                    <div className='d-flex flex-row gap-2'>
                        <div><FaCheckCircle size={20} style={{ "color": "#1D69BC" }} /></div>
                        <p>Advanced Promotions, Coupons, and Loyalty Features</p>
                    </div>
                    <div className='d-flex flex-row gap-2'>
                        <div><FaCheckCircle size={20} style={{ "color": "#1D69BC" }} /></div>
                        <p>Scalable Cloud Hosting and DevOps for high availability and performance</p>
                    </div>
                    <p className='text-size-medium py-3 text-center'>Whether you’re building a new digital storefront, re-platforming, or customizing an enterprise e-commerce engine, our team delivers solutions that drive engagement, streamline operations, and maximize revenue. </p>
                    <Image src={cs3} className='img-fluid rounded-24 pb-5' />
                </div>
            </section>
            <section className='px-5'>
                <div className='row'>
                    <div className='col-lg-6'>
                        <Image src={cs1} className='img-fluid rounded-24' />
                    </div>
                    <div className='col-lg-6'>
                        <Image src={cs2} className='img-fluid rounded-24' />
                    </div>
                </div>
            </section>
            <ServicesCard />
            <ContactBlock />
        </div >
    )
}
